export default "__VITE_ASSET__Bm4owBFm__"